// removed by extract-text-webpack-plugin
module.exports = {"text-overflow":"text-overflow___1uNdf"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/index.less
// module id = 746
// module chunks = 3